import { Box, Link } from '@mui/material'
import { Outlet } from 'react-router-dom'

const sx = {
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '15px 20px 15px 25px',
    gap: '218px',
    position: 'absolute',
    width: '100%',
    height: '55px',
    left: '0px',
    top: '0px',
  },
}

const UseBrowserLayout = () => {

  return (
        <>
          <Box sx={sx.header}>
            <Link href="https://markaaz.com">
              <img
                src="https://dashboard.app.markaaz.com/static/media/markaaz_logo_blue.043fce4d.png"
                width={90}
                alt="logo"
              />
            </Link>
          </Box>
          <Box sx={{ background: '#F2F8FC' }}>
            <Outlet />
          </Box>
        </>
    )
}

export default UseBrowserLayout
